// extracted by mini-css-extract-plugin
module.exports = {"content":"Page__content___196kn","banner":"Page__banner___1Q6JX","padded":"Page__padded___3hQ0U","mismatchModal":"Page__mismatchModal___1NikF"};